import React, { useState } from 'react';
import axios from 'axios';
import { site } from '../data/site';
import { SocialLinks } from '../components/SocialLinks';

const Contact: React.FC = () => {
  const [form, setForm] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
    company: '',
  });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const onChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    setError(null);
  };

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (form.company) {
      setSent(true);
      return;
    }
    setSending(true);
    setError(null);
    try {
      await axios.post('/api/contact', {
        name: form.name,
        email: form.email,
        subject: form.subject,
        message: form.message,
      });
      setSent(true);
      setForm({ name: '', email: '', subject: '', message: '', company: '' });
    } catch (err: unknown) {
      const message =
        axios.isAxiosError(err) && err.response?.data?.error
          ? String(err.response.data.error)
          : 'Mesaj gitmedi. Biraz sonra tekrar dene veya doğrudan e-posta at.';
      setError(message);
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="wrap contact-layout">
      <div>
        <p className="eyebrow">İletişim</p>
        <h1>Mustafa Gürses ile iletişim</h1>
        <p>
          Yazılımcı ve full stack developer Mustafa Gürses. Kurumsal yazılım, ERP ve dijital ürün
          ihtiyaçlarınız için birkaç gün içinde dönüş yapılır.
        </p>
        <div className="contact-direct">
          <a href={`mailto:${site.email}`}>{site.email}</a>
          <span style={{ color: 'var(--muted)' }}>{site.location}</span>
          {site.social.map((s) => (
            <a key={s.href} href={s.href} target="_blank" rel="noopener noreferrer">
              {s.label}
            </a>
          ))}
          {site.stores.map((s) => (
            <a key={s.href} href={s.href} target="_blank" rel="noopener noreferrer">
              {s.label}
            </a>
          ))}
        </div>
        <div style={{ marginTop: 24 }}>
          <SocialLinks />
        </div>
      </div>
      <div className="form">
        {sent ? (
          <div className="success-block">
            <h2>Geldi.</h2>
            <p>En kısa sürede dönüş yapacağım.</p>
          </div>
        ) : (
          <form onSubmit={onSubmit} noValidate>
            {error && <p className="form-msg">{error}</p>}
            <div className="hp" aria-hidden="true">
              <label htmlFor="company">Company</label>
              <input id="company" name="company" tabIndex={-1} autoComplete="off" value={form.company} onChange={onChange} />
            </div>
            <div className="field">
              <label htmlFor="name">Ad</label>
              <input id="name" name="name" value={form.name} onChange={onChange} required autoComplete="name" />
            </div>
            <div className="field">
              <label htmlFor="email">E-posta</label>
              <input id="email" name="email" type="email" value={form.email} onChange={onChange} required autoComplete="email" />
            </div>
            <div className="field">
              <label htmlFor="subject">Konu</label>
              <input id="subject" name="subject" value={form.subject} onChange={onChange} required />
            </div>
            <div className="field">
              <label htmlFor="message">Mesaj</label>
              <textarea id="message" name="message" rows={6} value={form.message} onChange={onChange} required />
            </div>
            <button type="submit" className="btn btn-fill" disabled={sending}>
              {sending ? 'Gönderiliyor…' : 'Gönder'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default Contact;
